(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[651],{

/***/ "qNL/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaPicture", function() { return MediaPicture; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var MediaPicture = function MediaPicture(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6703 14.2317L4.96484 18.9372V23.9955C4.96484 24.5703 5.43162 25.0361 6.00543 25.0361H23.9978C24.5706 25.0361 25.0364 24.5703 25.0364 23.9955V21.2602L21.0395 17.2653L17.5738 20.733C17.4024 20.9035 17.1715 20.9996 16.8692 21.0224C16.5868 21.0164 16.3519 20.9074 16.1725 20.7102L9.6703 14.2317ZM16.8712 18.6518L20.3378 15.1821C20.5232 14.9958 20.7838 14.8897 21.0514 14.8897C21.3229 14.8967 21.5588 15.0057 21.7412 15.2069L25.0364 18.4803V6.00395C25.0364 5.43113 24.5706 4.96533 23.9978 4.96533H6.00543C5.43162 4.96533 4.96484 5.43113 4.96484 6.00395V16.1741L8.96468 12.1505C9.14307 11.9731 9.40074 11.8849 9.65642 11.8849C9.9131 11.8849 10.1698 11.9731 10.3472 12.1495L16.8712 18.6518ZM6.00384 3H23.9962C25.6522 3 27 4.34783 27 6.00388V23.9954C27 25.6515 25.6522 27.0003 23.9962 27.0003H6.00384C4.34781 27.0003 3 25.6515 3 23.9954V6.00388C3 4.34783 4.34781 3 6.00384 3ZM19.4198 11.1362C20.1878 11.1362 20.8122 10.5118 20.8122 9.74373C20.8122 8.97666 20.1878 8.35229 19.4198 8.35229C18.6517 8.35229 18.0273 8.97666 18.0273 9.74373C18.0273 10.5247 18.6398 11.1362 19.4198 11.1362ZM19.4211 6.38599C21.2724 6.38599 22.7788 7.89239 22.7788 9.74367C22.7788 11.595 21.2724 13.1023 19.4211 13.1023C17.5699 13.1023 16.0625 11.595 16.0625 9.74367C16.0625 7.89239 17.5699 6.38599 19.4211 6.38599Z"
  }));
};

/***/ })

}]);